module.exports = __webpack_public_path__ + "img/yunzhi_code.ba197ffe.jpg";